import { Message } from 'element-ui';

/**
 * 根据图片地址获取图片的原始信息（原始宽高）
 * @param {string} url 图片地址
 * @returns {ImageNaturalInfo}
 */
export function getImageNaturalByUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const imgLoadSuccessHandler = () => {
      const naturalSize = { source: img };
      const supportFeature = img.naturalWidth && img.naturalHeight;
      naturalSize.width = img[supportFeature ? 'naturalWidth' : 'width'];
      naturalSize.height = img[supportFeature ? 'naturalHeight' : 'height'];
      resolve(naturalSize);
    };
    const imgLoadFailHandler = reject;
    Object.assign(img, {
      onload: imgLoadSuccessHandler,
      onerror: imgLoadFailHandler,
    });
    img.src = url;
  });
}

/**
 * 效验图片
 * @param {File} rawFile 图片文件
 * @param {Object} restriction 限制配置
 * @returns {Promise<Boolean>}
 */
export function validateImage(rawFile, restriction = {}) {
  return new Promise((resolve, reject) => {
    const URL = window.URL || window.webkitURL;
    const { type = ['image/jpeg', 'image/png'], max_size, width: restriction_width, height: restriction_height, width_ratio, height_ratio } = restriction;
    // 图片类型
    if (!type.includes(rawFile.type)) {
      const errMsg = `不支持${rawFile.type}类型的文件`;
      Message.error(errMsg);
      return reject(false);
    }
    getImageNaturalByUrl(URL.createObjectURL(rawFile)).then(({ width = 0, height = 0 }) => {
      // 宽高效验
      if (restriction_width && restriction_height) {
        if ((width !== restriction_width || height !== restriction_height)) {
          const errMsg = `图片要求宽高尺寸为：${restriction_width}px*${restriction_height}px`;
          Message.error(errMsg);
          return reject(false);
        }
      }

      // 宽高比例效验
      if (width_ratio && height_ratio) {
        // 交叉相乘判断比例是否一致
        if (width_ratio * height !== height_ratio * width) {
          const errMsg = `图片要求宽高比例为：${width_ratio}:${height_ratio}`;
          Message.error(errMsg);
          return reject(false);
        }
      }

      // 最大图片大小效验
      if (max_size && (rawFile.size > max_size)) {
        const errMsg = `图片大小不能超过${(max_size / 1024 / 1024)}MB`;
        Message.error(errMsg);
        return reject(false);
      }
      resolve(true);
    });
  });
}

export default {};
